import { useContext, useEffect, useState } from "react";
import { ChatInput } from "../../fusion/Chat";
import { useParams } from "react-router-dom";
import { ReactComponent as IconTemplate } from "../../../images/icon-template.svg";
import { ReactComponent as IconExport } from "../../../images/icon-download.svg";
import { ReactComponent as IconShare } from "../../../images/icon-share.svg";
import { ReactComponent as IconPinned } from "../../../images/icon-pinned.svg";
import { ReactComponent as IconRename } from "../../../images/icon-rename.svg";
import { ReactComponent as IconTrash } from "../../../images/icon-trash.svg";
import { ReactComponent as IconSharedChat } from "../../../images/icon-shared-chat.svg";
import { ReactComponent as LeaveChat } from "../../../images/icon-leave-chat.svg";

import { useChat } from "../contexts/ChatContext";
import { useMessages } from "../contexts/MessageContext";
import { useAccess } from "../contexts/AccessContext";
import { useTransientVisibility } from "../../fusion/Contexts/VisualContext";

const SymphonyChatInput = ({
	disableInput = false,
}) => {
	const params = useParams();
	const { isChatInContext, togglePinChat, isPinned, assistantThinking } =
		useChat();
	const { chatMembers, canShareChat, isChatOwner } = useAccess();
	const { sendMessage } = useMessages();
	const { show } = useTransientVisibility();

	const [contextMenuShown, setContextMenuShown] = useState(false);

	useEffect(() => {
		setContextMenuShown(false);
	}, [params.ChatId]);

	let chatActionsData = [
		{
		  className: "m-context-menu__item",
		  buttonClassName: `a-icon-link a-icon-link--block${
			isPinned ? " a-icon-link--active" : ""
		  }`,
		  text: isPinned ? "Unpin Chat" : "Pin Chat",
		  IconElement: <IconPinned className="a-icon-link__icon" />,
		  actionFunction: (e) => {
			e.preventDefault();
			togglePinChat();
		  },
		},
		{
		  className: "m-context-menu__item",
		  buttonClassName: "a-icon-link a-icon-link--block",
		  modalTarget: "rename-modal",
		  text: "Rename Chat",
		  IconElement: <IconRename className="a-icon-link__icon" />,
		  actionFunction: (e) => {
			e.preventDefault();
			show("RenameChatModal");
		  },
		},
		{
		  className: "m-context-menu__item",
		  buttonClassName: `a-icon-link a-icon-link--block ${
			!canShareChat ? "a-icon-link--disabled" : ""
		  }`,
		  text: "Share Chat",
		  IconElement: <IconShare className="a-icon-link__icon" />,
		  actionFunction: (e) => {
			e.preventDefault();
			if (canShareChat) show("ShareChatDrawer");
		  },
		},
		{
		  className: "m-context-menu__item",
		  buttonClassName: `a-icon-link a-icon-link--block ${
			!canShareChat ? "a-icon-link--disabled" : ""
		  }`,
		  text: "Export Chat",
		  IconElement: <IconExport className="a-icon-link__icon" />,
		  actionFunction: (e) => {
			e.preventDefault();
			show("ExportChatModal");
		  },
		},
		{
		  className: "m-context-menu__item",
		  buttonClassName: `a-icon-link a-icon-link--block a-icon-link--destructive ${
			assistantThinking ? "a-icon-link--disabled" : ""
		  }`,
		  text: isChatOwner ? "Delete Chat" : "Leave Chat",
		  IconElement: isChatOwner ? (
            <IconTrash className="a-icon-link__icon" />
          ) : (
            <LeaveChat className="a-icon-link__icon" />
          ),
		  actionFunction: (e) => {
			show(isChatOwner ? "DeleteChatModal" : "LeaveSharedChatModal");
			e.preventDefault();
		  },
		},
	];	  

	// {
		// 	className: "m-context-menu__item",
		// 	buttonClassName:
		// 		"a-icon-link a-icon-link--block a-icon-link--disabled",
		// 	text: "Create Template from Chat",
		// 	helpText: "Coming Soon",
		// 	IconElement: <IconTemplate className="a-icon-link__icon" />,
		// 	actionFunction: (e) => {
		// 		e.preventDefault();
		// 	},
		// },

	return (
		<ChatInput
			onSendMessage={(message) => {
				sendMessage(message);
			}}
			disableInput={disableInput}
			showContextButton={!(params.ChatId === undefined)}
			contextMenuShown={contextMenuShown}
			setContextMenuShown={setContextMenuShown}
			chatActions={chatActionsData}
			preContextMenuComponents={
				isChatInContext() && chatMembers.length > 1 ? (
					<button
						className="a-tag a-tag--interactive"
						data-drawer-target="sharing-drawer"
						onClick={(e) => {
							e.preventDefault();
							show("ShareChatDrawer");
						}}
					>
						<IconSharedChat />
						<p className="a-tag__label">
							{chatMembers.length} people in this chat
						</p>
					</button>
				) : (
					<></>
				)
			}
		/>
	);
};

export default SymphonyChatInput;
